import { render, staticRenderFns } from "./LiveJobCard.vue?vue&type=template&id=2009d64e&scoped=true&"
import script from "./LiveJobCard.vue?vue&type=script&lang=js&"
export * from "./LiveJobCard.vue?vue&type=script&lang=js&"
import style0 from "./LiveJobCard.vue?vue&type=style&index=0&id=2009d64e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2009d64e",
  null
  
)

export default component.exports